import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { Button, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import PercentIcon from "@mui/icons-material/Percent";
import { useDispatch, useSelector } from "react-redux";
import { setSortForBudget } from "../../../../../../../../../features/businessLeaderDashboardSlice";

const Puller = styled("div")(({ theme }) => ({
  width: spacing.Spacing["4xl"].$value,
  height: spacing.Spacing.xs.$value,
  backgroundColor: colors.GrayLightMode[300].$value,
  borderRadius: spacing.Radius.xs.$value,
  position: "absolute",
  top: spacing.Spacing.xl.$value,
  left: "calc(50% - 15px)",
  ...theme.applyStyles("dark", {
    backgroundColor: colors.GrayLightMode[300].$value,
  }),
}));

export default function BudgetShortBy() {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const { sortForBudget } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );

  const [sortedData, setSortedData] = React.useState(sortForBudget);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  // Toggle function to handle sorting option selection
  const handleToggle = (value: string, label: string) => {
    setSortedData({
      keytoSort: value,
      label: label,
      direction:
        sortedData.keytoSort === value && sortedData.direction === "asc"
          ? "desc"
          : "asc",
    });
  };

  // Apply the selected sorting option
  const handleApplySorting = () => {
    dispatch(setSortForBudget(sortedData));
    setOpen(false);
  };

  const options = [
    {
      label: "QFTD",
      value: "qftd",
      sort_icon: <ArrowUpwardIcon />,
    },
    { label: "Budget", value: "qftd_budget", sort_icon: <ArrowUpwardIcon /> },
    {
      label: "Budget Usage",
      value: "perc_Qftd_budget_use",
      sort_icon: <ArrowUpwardIcon />,
      icon: <PercentIcon />,
    },
    { label: "QFTD RR", value: "Qftd_RR", sort_icon: <ArrowUpwardIcon /> },
    {
      label: "RR Budget Usage",
      value: "perc_of_RR_qftd_budget_use",
      sort_icon: <ArrowUpwardIcon />,
      icon: <PercentIcon />,
    },
    { label: "Brand ID", value: "brand_id", sort_icon: <ArrowUpwardIcon /> },
  ];

  const ShortList = (
    <Box role="shortBy">
      <Puller />
      <Stack justifyContent={"end"} direction="row" p={1}>
        <IconButton
          aria-label="Logout"
          onClick={toggleDrawer(false)}
          sx={{
            width: spacing.Spacing["3xl"].$value,
            height: spacing.Spacing["3xl"].$value,
            color: colors.GrayLightMode[700].$value,
          }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>

      <Typography
        variant="body1"
        sx={{
          fontSize: typography.Size.Text.sm.$value,
          color: colors.GrayLightMode[700].$value,
        }}
      >
        Sort By
      </Typography>

      <Box sx={{ my: 2 }}>
        {options.map(({ label, value, sort_icon, icon }) => {
          //const isSelected = selected.includes(value);
          const isCurrentSort = sortedData.keytoSort === value;

          return (
            <Button
              key={value}
              onClick={() => handleToggle(value, label)}
              startIcon={
                isCurrentSort ? (
                  sortedData.direction === "asc" ? (
                    React.cloneElement(sort_icon, {
                      sx: {
                        position: "absolute",
                        left: "7px",
                        top: "7px",
                        transition: "0.2s",
                        width: spacing.Spacing.lg.$value,
                      },
                    })
                  ) : (
                    <ArrowUpwardIcon
                      sx={{
                        position: "absolute",
                        left: "7px",
                        top: "7px",
                        transform: "rotate(180deg)",
                        transition: "0.2s",
                        width: spacing.Spacing.lg.$value,
                      }}
                    />
                  )
                ) : (
                  <ArrowUpwardIcon
                    sx={{
                      position: "absolute",
                      left: "7px",
                      top: "7px",
                      opacity: 0,
                      width: spacing.Spacing.lg.$value,
                    }}
                  />
                )
              }
              endIcon={icon}
              variant={isCurrentSort ? "outlined" : "outlined"}
              color="secondary"
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: typography.Size.Text.sm.$value + "!important",
                },
                borderRadius: 2,
                mr: spacing.Spacing.sm.$value,
                mb: spacing.Spacing.sm.$value,
                py: spacing.Spacing.xs.$value,
                paddingRight: spacing.Spacing["1xl"].$value,
                paddingLeft: spacing.Spacing.xl.$value,
                textTransform: "capitalize",
                fontWeight: typography.Font_weight.Regular.$value,
                border: "1px solid" + colors.GrayLightMode[200].$value,
                color: colors.GrayLightMode[700].$value,
                fontSize: typography.Size.Text.xs.$value,
                ...(isCurrentSort && {
                  border: "1px solid" + colors.Brand[600].$value + "!important",
                  boxShadow: "none !important",
                  color: colors.GrayLightMode[900].$value,
                }),
              }}
            >
              {label}
            </Button>
          );
        })}
      </Box>

      <Button
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          boxShadow: "none !important",
          background: colors.Brand[600].$value,
          borderRadius: 2,
        }}
        onClick={handleApplySorting}
      >
        Apply
      </Button>
    </Box>
  );

  return (
    <>
      <IconButton
        data-tracker="661"
        sx={{
          backgroundColor: colors.Brand[50].$value,
          borderRadius: spacing.Radius.full.$value,
          "&:hover": {
            backgroundColor: colors.Brand[100].$value,
          },
        }}
        color="secondary"
        size="small"
        onClick={toggleDrawer(true)}
      >
        <FilterListOutlinedIcon
          sx={{ color: colors.GrayLightMode[700].$value }}
        />
      </IconButton>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: spacing.Radius.xl.$value,
            borderTopRightRadius: spacing.Radius.xl.$value,
            p: spacing.Spacing.xl.$value + "!important",
          },
        }}
      >
        {ShortList}
      </Drawer>
    </>
  );
}
